import { Play, Trophy } from 'lucide-react';
import { ROUTES } from '../config.ts';
import type { HomeData } from '../services/api.ts';
import { CloudBackground } from './CloudBackground.tsx';
import { GamesTopBar } from './GamesTopBar.tsx';

interface GameEntry { key: string; title: string; description: string; route: string; thumbnail: string }

// The catalog is a LIST, the same shape as the app's course list, so a student who knows
// the quiz app already knows how to pick a game. Add a game by adding an entry here; the
// route must be its own static entry so the catalog never imports Three.js.
const GAMES: GameEntry[] = [
  {
    key: 'smart-drive',
    title: 'Smart Drive',
    description: 'Dodge traffic and chase the weekly best.',
    route: ROUTES.smartDrive,
    thumbnail: '/smart-drive-preview.webp',
  },
];

export function GamesHome({ home, navigate }: { home: HomeData; navigate: (path: string) => void }) {
  return (
    <div className="games-home-page">
      <CloudBackground />
      <GamesTopBar home={home} navigate={navigate} />
      <main className="games-main rail">
        <header className="games-heading">
          <p className="eyebrow">Games</p><h1>Pick a game.</h1>
          <p>Tap a game to play.</p>
        </header>

        <ul className="game-list" aria-label="Games">
          {GAMES.map((game) => (
            <li key={game.key}>
              <button
                className="game-row"
                type="button"
                onClick={() => navigate(game.route)}
                aria-label={`Play ${game.title}`}
                aria-describedby={`game-${game.key}-description`}
              >
                <span className="game-row-thumb" aria-hidden="true">
                  <img src={game.thumbnail} width="930" height="510" alt="" />
                </span>
                <span className="game-row-copy">
                  <strong>{game.title}</strong>
                  <span id={`game-${game.key}-description`}>{game.description}</span>
                </span>
                <span className="game-row-play" aria-hidden="true"><Play size={18} /></span>
              </button>
            </li>
          ))}
        </ul>
        <p className="games-more">More games will appear here as they are ready.</p>

        <button className="leaderboard-card" type="button" onClick={() => navigate(ROUTES.leaderboard)}>
          <span className="leaderboard-road" aria-hidden="true"><span /><span /></span>
          <span className="leaderboard-copy"><span className="leaderboard-label">Smart Drive</span><strong>View leaderboard</strong><span>Today, this week, and all time</span></span>
          <span className="leaderboard-icon" aria-hidden="true"><Trophy size={22} /></span>
        </button>
      </main>
    </div>
  );
}
